module.exports = __webpack_public_path__ + "img/recruit_copy2.0f31f552.png";